var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEquatorialGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 10.4456H31.0045C28.7438 4.35274 22.8791 0.0107422 15.9997 0.0107422C11.5813 0.0107422 7.58177 1.80193 4.68652 4.69755L9.73884 10.4456Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 21.5759H31.0045C28.7438 27.6687 22.8791 32.0107 15.9997 32.0107C11.5813 32.0107 7.58177 30.2196 4.68652 27.3239L9.73884 21.5759Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.69702C-1.56212 10.9454 -1.56212 21.0761 4.68625 27.3245C7.26831 24.7425 9.75163 22.2591 16 16.0108L4.68625 4.69702Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7822 13.228V16.7063C18.7822 18.8363 21.5649 19.489 21.5649 19.489C21.5649 19.489 24.3475 18.8363 24.3475 16.7063V13.228H18.7822Z",
    fill: "#DEDDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8691 16.0803H22.2605V18.0977H20.8691V16.0803Z",
    fill: "#786145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9568 15.3151C22.9568 14.5467 22.3339 13.9238 21.5655 13.9238C20.797 13.9238 20.1741 14.5467 20.1741 15.3151C19.79 15.3151 19.4785 15.6266 19.4785 16.0108C19.4785 16.395 19.79 16.7064 20.1741 16.7064H22.9568C23.341 16.7064 23.6524 16.395 23.6524 16.0108C23.6524 15.6266 23.341 15.3151 22.9568 15.3151Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEquatorialGuinea);
export default __webpack_public_path__ + "static/media/flag_equatorial_guinea.b74260508bb3dc23d9abc191cfb17669.svg";
export { ForwardRef as ReactComponent };